import type { SVGProps } from 'react';

export const Archive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'archive'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g>
        <rect height="32" width="32" x="0" y="0" />
        <g fill={props.fill} transform="translate(0.000000, 3.000000)">
          <path d="M0,7.52941176 L0,2.82352941 C0,1.26682353 1.26682353,-1.33226763e-14 2.82352941,-1.33226763e-14 L29.1764706,-1.33226763e-14 C30.7331765,-1.33226763e-14 32,1.26682353 32,2.82352941 L32,7.52941176 L0,7.52941176 Z M29.1764706,1.88235294 L2.82352941,1.88235294 C2.304,1.88235294 1.88235294,2.30494118 1.88235294,2.82352941 L1.882,5.647 L30.117,5.647 L30.1176471,2.82352941 C30.1176471,2.30494118 29.696,1.88235294 29.1764706,1.88235294 Z M3.76470588,7.52941176 L3.76470588,23.5294118 C3.76470588,24.048 4.18635294,24.4705882 4.70588235,24.4705882 L27.2941176,24.4705882 C27.8136471,24.4705882 28.2352941,24.048 28.2352941,23.5294118 L28.2352941,7.52941176 L30.1176471,7.52941176 L30.1176471,23.5294118 C30.1176471,25.0861176 28.8508235,26.3529412 27.2941176,26.3529412 L4.70588235,26.3529412 C3.14917647,26.3529412 1.88235294,25.0861176 1.88235294,23.5294118 L1.88235294,7.52941176 L3.76470588,7.52941176 Z M19.7647059,11.2941176 C20.2851765,11.2941176 20.7058824,11.7157647 20.7058824,12.2352941 C20.7058824,12.7548235 20.2851765,13.1764706 19.7647059,13.1764706 L12.2352941,13.1764706 C11.7148235,13.1764706 11.2941176,12.7548235 11.2941176,12.2352941 C11.2941176,11.7157647 11.7148235,11.2941176 12.2352941,11.2941176 L19.7647059,11.2941176 Z" />
        </g>
      </g>
    </g>
  </svg>
);
